import React, { Component } from "react";
import KickImage from 'Reuseables/KickImage';
import { connect } from "react-redux";
import { Row, Col, Container } from "reactstrap";
import { Link } from "react-router-dom";
import {
  StealDeals,
  SpecialDeals,
  LocalBrandsSection,
  OfficialMerchandise,
  RaffleSection,
  TradingPit,
  ExclusiveLaunch,
  SurpriseDrop
} from "./kickAvenueFair";
import {
  getRaffleGroup,
  getUserRaffleTickets
} from "../../actions/kafairAction";

class KickFairContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.props.getRaffleGroup();
    this.props.getUserRaffleTickets();
  }

  render() {
    const { raffle, raffleGroup } = this.props;

    const raffles = raffleGroup
      ? raffleGroup.map(rg => {
        return {
          ...raffle[rg.query],
          ticket_name: rg.ticket_name,
          ticket_type: rg.ticket_type,
          key: rg.key,
          title: rg.title,
          color: rg.color
        };
      })
      : [];

    return (
      <div>
        <TradingPit history={this.props.history} />
        <div ref={this.props.fairGroundRef} id="steal-deals-id">
          <StealDeals history={this.props.history} />
        </div>
        <div ref={this.props.goldZoneRef} id="gold-zone-id">
          <SpecialDeals
            history={this.props.history}
            slug="special-deals-gold"
            name="special_deals_gold"
            raffle={raffles[0]}
          />
        </div>
        {/* {
          raffleGroup0 && (
            <div ref={this.props.fairGroundRef} id="gold-raffle">
              <RaffleSection 
                title={raffleGroup0.group_name}
                products={raffleGroup0.products}
                isGolden={raffleGroup0.golden}
                start_date={raffleGroup0.start_date}
                expiry_date={raffleGroup0.expiry}
                history={this.props.history}
              />
            </div>
          )
        } */}
        <div ref={this.props.surpriseDropRef} id="surprise-drop-id">
          <SurpriseDrop history={this.props.history} />
        </div>
        <div ref={this.props.indonesianBrandsRef} id="indonesian-brands-id">
          <LocalBrandsSection history={this.props.history} />
        </div>
        <div ref={this.props.redZoneRef} id="red-zone-id">
          <SpecialDeals
            history={this.props.history}
            slug="capsule-zone"
            name="special_deals_capsule"
            hideSpecialDeals={true}
            raffle={raffles[1]}
          />
        </div>
        <div ref={this.props.exclusiveLaunchRef} id="exclusive-launch-id">
          <ExclusiveLaunch history={this.props.history} />
        </div>
        <div ref={this.props.purpleZoneRef} id="purple-zone-id">
          <SpecialDeals
            history={this.props.history}
            slug="capsule-zone"
            name="special_deals_capsule"
            raffle={raffles[2]}
          />
        </div>
        <div ref={this.props.officialMerchRef} id="official-merch-id">
          <OfficialMerchandise history={this.props.history} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  raffle: state.dataKaFair.raffle,
  raffleGroup: state.dataKaFair.raffleGroup.data
});

const mapDispatchToProps = dispatch => ({
  getUserRaffleTickets: () => dispatch(getUserRaffleTickets()),
  getRaffleGroup: () => dispatch(getRaffleGroup())
});

export default connect(mapStateToProps, mapDispatchToProps)(KickFairContainer);
